import { FC } from 'react';

import { EmployeeInfo } from 'src/components/EmployeeInfo/EmployeeInfo';
import { Section } from 'src/components/Section/Section';

import { BookingData } from './BookingData';

export interface GuestProps {
  guest: boolean;
  spaceAdministrator?: string;
}

export const GuestInfo: FC<GuestProps> = ({ guest, spaceAdministrator }) => {
  return (
    <>
      <BookingData guest={guest} />

      {spaceAdministrator && (
        <Section title='Ответственный по блоку' testId='responsibleSection'>
          <EmployeeInfo
            employeeNumber={spaceAdministrator}
            testId='responsible'
          />
        </Section>
      )}
    </>
  );
};
